import request from "@/utils/request.js"

// 审核拒绝退款
export const rejectRefund = (updateData) => {
    return request.put(`/admin/refund/${updateData.refundId}/reject?rejectReason=${updateData.rejectReason}`);
};

// 审核通过退款
export const approveRefund = (updateData) => {
    return request.put(`/admin/refund/${updateData.refundId}/approve`);
};
